<div class="page">
  <div class="btn-setting">
    <div class="btn-box">
      <ssg-button
        class="send-item-btn"
        [label]="'ClientApp.FrontOffice.Portal.ConnectOnlineMenu.CommunicationTest' | translate"
        [disabled]="isLoading"
        (click)="ConnectionTest()"></ssg-button>
    </div>
    <div class="btn-box" *ngIf="testConnection || showBtn">
      <ssg-button
        class="send-item-btn"
        [label]="'ClientApp.FrontOffice.Portal.ConnectOnlineMenu.DisplayInformation' | translate"
        [disabled]="isLoading || !showBtn"
        (click)="ShowInfo()"></ssg-button>
    </div>
    <div class="btn-box" *ngIf="GetInfo && (ResInfo || showBtn)">
      <ssg-button
        class="send-item-btn"
        [label]="'ClientApp.FrontOffice.Portal.ConnectOnlineMenu.RegisterInOnlineMenu' | translate"
        [disabled]="isLoading || !showBtn"
        (click)="Register()"></ssg-button>
    </div>
    <div class="btn-box" *ngIf="isRegister && GetInfo && (ResInfo || showBtn)">
      <ssg-button
        class="send-item-btn"
        [label]="'ClientApp.FrontOffice.Portal.ConnectOnlineMenu.SendProductGroupInformation' | translate"
        [disabled]="isLoading"
        (click)="SendItemCategoryInfo()"></ssg-button>
    </div>
    <div class="btn-box" *ngIf="isRegister && GetInfo && (ResInfo || showBtn)">
      <ssg-button
        class="send-item-btn"
        [label]="'ClientApp.FrontOffice.Portal.ConnectOnlineMenu.SendProductInformation' | translate"
        [disabled]="isLoading"
        (click)="SendItemInfo()"></ssg-button>
    </div>
  </div>
  <div class="contentbox" *ngIf="ResInfo">
    <div class="contextbox-restaurant">
      <div>
        <span class="title">{{ "ClientApp.FrontOffice.Portal.ConnectOnlineMenu.NameOfRestaurant" | translate }} :</span>
        <span class="value">{{ ResInfo?.Title }}</span>
      </div>
      <div class="info1">
        <span class="title">{{ "ClientApp.FrontOffice.Portal.ConnectOnlineMenu.LockNumber" | translate }} :</span>
        <span class="value">{{ ResInfo?.LockNumber }}</span>
      </div>
      <div class="info1">
        <span class="title">{{ "ClientApp.FrontOffice.Portal.ConnectOnlineMenu.ManagerMobileNumber" | translate }} :</span>
        <span class="value">{{ ResInfo?.ManagerMobile }}</span>
      </div>
      <div class="info1">
        <span class="title">{{ "ClientApp.FrontOffice.Portal.ConnectOnlineMenu.AddressRestaurant" | translate }} :</span>
        <span class="value">{{ ResInfo?.Address }}</span>
      </div>
      <div class="info1">
        <span class="title">{{ "ClientApp.FrontOffice.Portal.ConnectOnlineMenu.Company" | translate }} :</span>
        <span class="value">{{ ResInfo?.BrandName }}</span>
      </div>
    </div>
    <div class="info2" *ngFor="let url of ResInfo.Urls; let index = index" style="display: flex">
      <span class="title">{{ ResInfo.BranchInfoes[index].Title }} :</span>
      <div class="d-flex">
        <input class="text-url" type="url" dir="ltr" [value]="url" #userinput />
        <ssg-button
          class="button-url"
          [label]="'ClientApp.FrontOffice.Portal.ConnectOnlineMenu.CopyAddress' | translate"
          [disabled]="isLoading"
          (click)="copyInputMessage(userinput)"></ssg-button>
      </div>
    </div>
  </div>
</div>
